import React from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

interface SettingProps {
    title: string;
    children: React.ReactNode;
    onInfoClick?: () => void;
    id?: string;
}

export const Setting = ({ title, children, onInfoClick, id }: SettingProps) => (
    <div className="card-control__settings__setting" id={id}>
        <div className="card-control__settings__setting__header">
            <h3 className="h3">{title}</h3>
            {onInfoClick && (
                <IconButton screenReaderText="info" icon={IconTypes.INFO_24} onClick={() => onInfoClick()} />
            )}
        </div>
        <div className="card-control__settings__setting__content">{children}</div>
    </div>
);
